import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { caricaGA } from '../utils/analytics';

// Banner cookie con consenso per l'analitica (Google Analytics).
// I cookie tecnici (login) sono sempre attivi; GA parte solo con "Accetta".
// La scelta è in localStorage ('cookie_consent' = 'all' | 'necessary').
function CookieBanner() {
  const [visibile, setVisibile] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) setVisibile(true);
  }, []);

  if (!visibile) return null;

  const salva = (scelta) => {
    localStorage.setItem('cookie_consent', scelta);
    if (scelta === 'all') caricaGA();
    setVisibile(false);
  };

  return (
    <div className="cookie-banner">
      <p>
        Usiamo cookie tecnici necessari (incluso il login) e, con il tuo consenso, cookie di
        analisi per capire come viene usato il sito. Consulta la <Link to="/privacy">privacy policy</Link>.
      </p>
      <div className="cookie-banner-actions">
        <button className="home-btn" onClick={() => salva('necessary')}>Solo necessari</button>
        <button className="home-btn home-btn-primary" onClick={() => salva('all')}>Accetta</button>
      </div>
    </div>
  );
}

export default CookieBanner;
